import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddZileComponent } from './add-zile/add-zile.component';
import { EditZileComponent } from './edit-zile/edit-zile.component';
import { ZileLibereComponent } from './zile-libere.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [ZileLibereComponent, EditZileComponent, AddZileComponent],
    imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
    exports: [ZileLibereComponent],
})
export class ZileLibereModule { }
